<mat-toolbar color="primary">
    <button mat-icon-button (click)="sidenav.toggle()">
        <mat-icon style="color: white;">menu</mat-icon>
    </button>
    <a routerLink="/home" class="homeLink">
        <img class="logo-img desktop" alt="Company Logo" src="../../assets/logo-Amrize.svg" />
        <img class="logo-img mobile" alt="Company Logo" src="../../assets/favicon.svg" />
    </a>
    <span class="toolbar-spacer"></span>
    <span class="siteName">Cement Certification Tool</span>
    <span class="toolbar-spacer"></span>
    <button mat-icon-button [matMenuTriggerFor]="menu">
        <mat-icon style="color: white;">more_vert</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
        <button mat-menu-item [matTooltip]="loggedInObj.email">
            <span *ngIf="loggedInObj">{{loggedInObj.email}}</span>
        </button>
        <button mat-menu-item (click)="logOut()">
            <mat-icon>logout</mat-icon>
            <span>Logout</span>
        </button>
    </mat-menu>
</mat-toolbar>